import React, { useRef, useEffect, useState, useCallback } from 'react';

const DJPalScrollableList = ({ children, maxHeight, onScrollBottom }) => {
    const listRef = useRef(null);
    const [hasOverflow, setHasOverflow] = useState(false);
    const firedRef = useRef(false);

    useEffect(() => {
        const el = listRef.current;
        if (el) {
            setHasOverflow(el.scrollHeight > el.clientHeight);
        }
    }, [children]);

    // Reset the fired flag when new children load (scroll height changes)
    useEffect(() => {
        firedRef.current = false;
    }, [children]);

    const handleScroll = useCallback(() => {
        if (!onScrollBottom) return;
        const el = listRef.current;
        if (!el) return;
        const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 100;
        if (nearBottom && !firedRef.current) {
            firedRef.current = true;
            onScrollBottom();
        } else if (!nearBottom) {
            // User scrolled away from bottom — allow next trigger
            firedRef.current = false;
        }
    }, [onScrollBottom]);

    return (
        <div
            ref={listRef}
            className={`djpal-scrollable-list ${hasOverflow ? 'has-overflow' : ''}`}
            style={maxHeight ? { maxHeight } : undefined}
            onScroll={handleScroll}
        >
            {children}
        </div>
    );
};

export default DJPalScrollableList;
